
import React from 'react';
import { useParams } from 'react-router-dom';
import { useCompanyProfileData } from '@/hooks/useCompanyProfileData';
import ProfilePageWrapper from '@/components/company-profile/ProfilePageWrapper';
import ProfileContent from '@/components/company-profile/ProfileContent';

const CompanyProfile = () => {
  const { companyId, companyName } = useParams<{ companyId: string; companyName: string }>();
  const paramId = companyId || companyName;
  
  const { 
    company, 
    decodedCompanyName, 
    isLoading, 
    companyStats,
    reviewData,
    categoryData
  } = useCompanyProfileData(paramId || '');

  return (
    <ProfilePageWrapper>
      <ProfileContent
        company={company}
        decodedCompanyName={decodedCompanyName}
        companyStats={companyStats}
        reviewData={reviewData}
        categoryData={categoryData}
        isLoading={isLoading}
      />
    </ProfilePageWrapper>
  );
};

export default CompanyProfile;
